<template>
    <div class="modal-sm modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Списание баланса</h3>
          <button type="button" class="close" @click="hide()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert alert-success my-1" v-if="this.region">
          Текущий баланс: {{this.region.money}}
        </div>
        <div v-if="regionData" class="modal-body">
          <input-form-custom
            name="count"
            v-model="regionData.count"
            label="Сумма списания"
            :rule="{ required: true, regex: /^[0-9]{1,6}([.][0-9]{1,2})?$/ }"
            class="mb-3"
            inputClass="form-control"
          />
        </div>
        <div class="alert alert-danger my-1" v-if="validationError">
          {{validationError}}
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <btn-action
            class="btn btn-primary"
            @click="save"
          >Списать</btn-action>
        </div>
      </div>
    </div>
  </template>
  <script>
    import api from '@/api'
    import {pick, cloneDeep} from 'lodash'
  
    export default {
      props: ['region'],
      data () {
        return {
          regionData: {
              region: this.region
          },
          validationError: '',
          balance: 0,
        }
      },
      methods: {
        save () {
          this.balance = Number(this.regionData.count) + Number(this.region.money)
          api.post(`billing/regions/withdraw/`, {count: this.regionData.count, region_id: this.region.id})
          .then(({data}) => {
                this.hide(false)
                window.alert(`Баланс успешно уменьшен`)
              })
          .catch(this.handleError)
        },
        hide (refresh = false) {
          this.$emit('hide', {
            refresh: refresh,
          })
        },
        handleError (error) {
          if (error.response && error.response.status === 422) {
            let obj = error.response.data.validation
            this.validationError = obj[Object.keys(obj)[0]][0]
          } else {
            throw error
          }
        },
      },
      mounted () {
        if (this.user) {
          this.regionData = pick(this.user, ['count'])
        } else {
          this.regionData = {
              count: '',
            }
        }
      },
    }
  </script>
  


// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/region-write-off-balance.vue